import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, TargetIcon, FileTextIcon, SettingsIcon, SparklesIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function MethodSection() {
  const methods = [{
    letter: 'R',
    title: 'Rápido',
    desc: 'prompts listos para usar en segundos.',
    icon: <ZapIcon className="w-6 h-6 text-cyan-neon" data-id="element-116" />
  }, {
    letter: 'E',
    title: 'Específico',
    desc: 'soluciones adaptadas a tu vida cotidiana.',
    icon: <TargetIcon className="w-6 h-6 text-cyan-neon" data-id="element-117" />
  }, {
    letter: 'S.C.',
    title: 'Concreto',
    desc: 'ejemplos directos y claros, sin paja.',
    icon: <FileTextIcon className="w-6 h-6 text-cyan-neon" data-id="element-118" />
  }, {
    letter: 'A',
    title: 'Automatizado',
    desc: 'mini flujos con herramientas que ya usas.',
    icon: <SettingsIcon className="w-6 h-6 text-cyan-neon" data-id="element-119" />
  }, {
    letter: 'T.E.',
    title: 'Transformador',
    desc: 'conviertes tareas complejas en simples.',
    icon: <SparklesIcon className="w-6 h-6 text-cyan-neon" data-id="element-120" />
  }];
  return <section className="py-24 px-6 bg-gradient-to-b from-navy-700 to-navy-600 relative overflow-hidden" data-id="element-121">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[1px] bg-gradient-to-r from-transparent via-cyan-neon/50 to-transparent" data-id="element-122"></div>

      <div className="max-w-6xl mx-auto" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-124">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-125">
            Te presentamos el Método{' '}
            <span className="text-cyan-neon drop-shadow-[0_0_15px_rgba(0,242,255,0.5)]" data-id="element-126">
              R.E.S.C.A.T.E.
            </span>
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-127">
            La fórmula práctica para desbloquear el poder de ChatGPT en tu día a
            día.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 justify-center" data-id="element-128">
          {methods.map((method, i) => <motion.div key={i} variants={itemVariants} className="bg-cyan-neon/[0.03] border border-cyan-neon/20 hover:border-cyan-neon/50 transition-colors rounded-2xl p-6 flex flex-col items-start relative group overflow-hidden" data-id="element-129">
              <div className="absolute -right-4 -top-4 w-24 h-24 bg-cyan-neon/10 rounded-full blur-2xl group-hover:bg-cyan-neon/20 transition-all" data-id="element-130"></div>

              <div className="bg-navy-900 border border-cyan-neon/30 p-3 rounded-xl mb-6 shadow-[0_0_15px_rgba(0,242,255,0.1)]" data-id="element-131">
                {method.icon}
              </div>

              <h3 className="text-xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-132">
                <span className="text-cyan-neon" data-id="element-133">{method.title}</span>
              </h3>

              <p className="text-slate-300 leading-relaxed" data-id="element-134">{method.desc}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}